import React, { useRef, useState } from "react";
import CustomModal from "../modal/customModal";
import ProductMediaGallery from "../ProductMediaGallery/ProductMediaGallery";
import useDarkMode from "../../../hooks/useDarkMode";
import useThemeColor from "../../../hooks/useThemeColor";
import { toDisplayMediaUrl } from "../../../utils/mediaImageUtils";

const ImageUploadWithGallery = ({
  compID,
  imageUrl,
  setImage,
  imageFile,
  mediaCategory = "Product",
  className = "",
  marginLeft = "40px",
  height = "180px",
  width = "180px",
  buttonText = "Change image",
  uploadText = "Choose from gallery",
  onRemove,
  centerButton = false,
  useGrid = true,
}) => {
  const [showGallery, setShowGallery] = useState(false);
  const isDarkMode = useDarkMode();
  const themeColor = useThemeColor();
  const displayUrl = imageUrl ? toDisplayMediaUrl(imageUrl) : "";

  const handleRemoveImage = () => {
    setImage("", null);
    if (onRemove) onRemove();
  };

  const handleGallerySelect = (fullUrl, relativePath) => {
    const urlForPreview = fullUrl || toDisplayMediaUrl(relativePath);
    setImage(urlForPreview, null);
    setShowGallery(false);
  };

  const containerClass = useGrid ? `col-md-3 text-center ${className}` : `text-center ${className}`;
  const buttonDivClass = `d-flex ${centerButton ? "justify-content-center" : ""}`;
  const buttonStyle = { marginLeft: centerButton ? "0" : marginLeft };

  return (
    <>
      <div className={containerClass}>
        <div
          className="overflow-hidden position-relative mb-3 mx-auto"
          style={{
            width,
            height,
            border: displayUrl ? "none" : isDarkMode ? "2px dashed #555" : "2px dashed #D9D9D9",
            borderRadius: "20px",
            backgroundColor: isDarkMode ? "#404040" : "#ffffff",
          }}
        >
          {displayUrl ? (
            <>
              <img
                src={displayUrl}
                className="img-fluid"
                alt="Preview"
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                  borderRadius: "20px",
                }}
                onClick={() => setShowGallery(true)}
              />
              <i
                className="fa fa-times text-danger position-absolute"
                style={{
                  top: "10px",
                  right: "10px",
                  cursor: "pointer",
                  fontSize: "1rem",
                  background: "rgba(255, 255, 255, 0.8)",
                  padding: "3px",
                  borderRadius: "50%",
                }}
                onClick={handleRemoveImage}
              />
            </>
          ) : (
            <div
              className="d-flex flex-column align-items-center justify-content-center h-100"
              style={{
                cursor: "pointer",
                color: isDarkMode ? "#ffffff" : "#6c757d",
              }}
              onClick={() => setShowGallery(true)}
            >
              <i
                className="fa-solid fa-images"
                style={{ fontSize: "2.5rem", color: isDarkMode ? "#ffffff" : "#6c757d" }}
              />
              <p className="mt-2 mb-0" style={{ color: isDarkMode ? "#ffffff" : "#6c757d" }}>
                {uploadText}
              </p>
            </div>
          )}
        </div>
      </div>
      {displayUrl && (
        <div className={buttonDivClass} style={buttonStyle}>
          <button
            type="button"
            className="btn btn-sm rounded-pill"
            onClick={() => setShowGallery(true)}
            style={{
              backgroundColor: themeColor,
              borderColor: themeColor,
              color: "white",
            }}
          >
            {buttonText}
          </button>
        </div>
      )}

      <CustomModal
        title="Media gallery"
        isOpen={showGallery}
        onClose={() => setShowGallery(false)}
        showButton={false}
        modalSize="modal-lg"
        maxHeight="85vh"
        themeColor={themeColor}
      >
        {compID ? (
          <ProductMediaGallery
            compID={compID}
            mediaCategory={mediaCategory}
            selectedPath={imageUrl}
            onSelectImage={handleGallerySelect}
          />
        ) : (
          <p className="text-muted text-center py-4">Company context is required to open the gallery.</p>
        )}
      </CustomModal>
    </>
  );
};

export default ImageUploadWithGallery;
